import React, { useRef, useState, useEffect, useCallback } from "react";
import TweetEmbed from "react-tweet-embed";
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad";
import AnimateHeightWrapper, { AnimateWrapperButton } from "../../Parts/Brid/common/components/AnimateHeightWrapper";
import AnimateFixedHeightWrapper from "../../Parts/Brid/common/components/AnimateFixedHeightWrapper";

import shareIcon from "../../../../redesign/assets/icons/socialbutton-share.svg"
import useMediaQuery from "../../../../helpers/useMediaQuery";

const TwitterPost = ({ dataId }) => {
  const isDesktop = useMediaQuery('bp4');
  const [visibility, setVisibility] = useState(false);
  const heightValue = isDesktop ? 450 : 275;

  const handleTweetLoad = useCallback((twitterWidgetElement) => {
    const height = twitterWidgetElement.getBoundingClientRect().height;
    if (height > heightValue)
      setVisibility(true);
  });

  return (
    <WithLazyLoad options={{
      height: 480,
      once: true,
      offset: 600
    }}>
      <AnimateFixedHeightWrapper>
        <CenteredEmbed>
          <TweetEmbed tweetId={dataId} options={{ lang: "pl" }} id={dataId} onTweetLoadSuccess={handleTweetLoad} />
        </CenteredEmbed>
      </AnimateFixedHeightWrapper>
    </WithLazyLoad>
  );
}

export default TwitterPost;

const CenteredEmbed = styled("div", {
  "& > div > .twitter-tweet": {
    margin: "10px auto !important"
  },
  minHeight: "350px",
  positon: "relative",
  "&::before": {
    minHeight: "350px",
    height: "100%",
    content: "",
    background: `transparent url("${shareIcon}") no-repeat center center`,
    backgroundSize: "60px",
    opacity: 0.4,
    top: "0",
    left: "0",
    right: "0",
    position: "absolute",
    zIndex: 0
  },
  iframe: {
    position: "relative !important"
  }
})